import { environment } from '../environments/environment';

export const bugsnagClientConfiguration: any = {
    apiKey: environment.bugsnagApikey,
    appVersion: environment.appVersion,
    releaseStage: environment.releaseStage,
    enabledReleaseStages: ['development', 'production'],

    onError: function (event: any) {

        event.addMetadata('app', {
            environment:  environment.releaseStage,
            apiUrl:       (environment as any).apiUrl ?? 'unknown',
            appVersion:   environment.appVersion,
        });

        event.addMetadata('device_context', {
            screenWidth:  window.innerWidth,
            screenHeight: window.innerHeight,
            language:     navigator.language,
            online:       navigator.onLine,
            platform:     navigator.platform,
            href:         window.location.href,
        });

        const userId = localStorage.getItem('userId');
        const role   = localStorage.getItem('role');
        if (userId && !event.getUser()?.id) {
            event.setUser(userId, undefined, role ?? undefined);
        }

        return true;
    },

    metaData: {
        company: {
            name: 'Brightside',
            country: 'uk',
        },
    },
};
